import { Toggle } from "rsuite";

interface Props {
  onUpdateAction: (newAction: boolean) => void;
  matchReferences: boolean;
}

const MatchReferencesConfig = ({ onUpdateAction, matchReferences }: Props) => {
  return (
    <>
      <h4>Match Reference Records</h4>
      <p>
        <small>
          Set to true to try to match Reference fields with existing records
          based on the Reference Name. Otherwise they will be created.
        </small>
      </p>
      <Toggle
        onChange={(val: boolean) => onUpdateAction(val)}
        checked={matchReferences}
      />
    </>
  );
};

export default MatchReferencesConfig;
